import React from "react";

import type { HubPlatform } from "../../data/hub-platforms";

export const PlatformCard: React.FC<{ platform: HubPlatform }> = ({ platform }) => (
  <div className="col">
    <div className="card shaded hub-platform-card h-100" data-testid={`hub-platform-${platform.id}`}>
      <div className="card-body">
        <div className="hub-platform-header">
          <span className="hub-platform-icon" aria-hidden="true">
            <span className="fas fa-link"></span>
          </span>
          <div className="hub-platform-heading">
            {!!platform.eyebrow && <span className="hub-platform-eyebrow">{platform.eyebrow}</span>}
            <a className="hub-platform-name" href={platform.url} target="_blank" rel="noopener noreferrer">
              {platform.name}
            </a>
          </div>
        </div>
        <ul className="hub-platform-bullets">
          {platform.bullets.map(bullet => (
            <li key={bullet}>{bullet}</li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);
